var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgForecastIconBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 11,
  height: 11,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0H10L6.42857 4L10 8H0V0Z",
  fill: "#1A1A24"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 8,
  width: 2,
  height: 3,
  fill: "#1A1A24"
})));
export { SvgForecastIconBlack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxMSAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMEgxMEw2LjQyODU3IDRMMTAgOEgwVjBaIiBmaWxsPSIjMUExQTI0Ii8+CjxyZWN0IHk9IjgiIHdpZHRoPSIyIiBoZWlnaHQ9IjMiIGZpbGw9IiMxQTFBMjQiLz4KPC9zdmc+Cg==";